import { useEffect, useState } from 'react';
import { getCompanies } from 'api';

export function useCustomers() {
	const [customers, setCustomers] = useState<{ Id: string; Name: string }[]>(
		[],
	);
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		const loadCustomers = async () => {
			setLoading(true);
			try {
				const data = await getCompanies();
				setCustomers(data || []);
			} catch (error) {
				console.error('Failed to load customers', error);
			} finally {
				setLoading(false);
			}
		};
		loadCustomers();
	}, []);

	return { customers, loading };
}
